<template>
  <form
    method="GET"
    action="/search"
  >
    <div class="container-max">
      <div class="position-relative">
        <div class="d-flex flex-grow-1 position-relative my-2">
          <input
            ref="searchInput"
            name="query"
            type="search"
            class="search-input flex-grow-1 px-3 py-2"
            role="presentation"
            autocomplete="off"
            spellcheck="false"
            @keyup.enter="prepareSearch()"
            @keyup.down="keydown()"
            @keyup.up="keyup()"
            @focus="isSearchFocused = true"
            @blur="setIsSearchFocused(false)"
          >
          <button
            class="search-submit px-3"
            type="submit"
            @click="search()"
            :aria-label="$translate('Ceres::Template.headerSearch')"
          >
            <i
              class="fa fal fa-search"
              aria-hidden="true"
            />
          </button>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { getUrlParams } from '../../mixins/url'

export default {
    name: 'ItemSearch',

    props: {
        showItemImages: {
            type: Boolean,
            default: false
        },
        forwardToSingleItem: {
            type: Boolean,
            default: App.config.search.forwardToSingleItem
        }
    },

    data () {
        return {
            promiseCount: 0,
            autocompleteResult: [],
            selectedAutocompleteIndex: -1,
            isSearchFocused: false
        }
    },

    computed:
            {
                selectedAutocompleteItem () {
                    return null
                }
            },

    mounted () {
        this.$nextTick(() => {
            const urlParams = getUrlParams(document.location.search)

            this.$store.commit('setItemListSearchString', urlParams.query)

            const rawQuery = urlParams.query ? urlParams.query : ''
            // Manually regex out all "+" signs as decodeURIComponent does not take care of that.
            // If we wouldn't replace them with spaces, "+" signs would be displayed in the search field.
            this.$refs.searchInput.value = decodeURIComponent(rawQuery.replace(/\+/g, ' '))
        })
    },

    methods:
            {
                prepareSearch () {
                    $('#searchBox').collapse('hide')
                },

                search () {
                    // let searchBaseURL = '/search?query='
                    //
                    // if (App.defaultLanguage !== App.language) {
                    //     searchBaseURL = `/${App.language}/search?query=`
                    // }
                    //
                    // window.open(searchBaseURL + this.$refs.searchInput.value, '_self', false)
                },

                autocomplete (searchString) {
                },

                selectAutocompleteItem (item) {
                },

                keyup () {
                },

                keydown () {
                },

                // hide autocomplete after 100ms to make clicking on it possible
                setIsSearchFocused (value) {
                    setTimeout(() => {
                        this.isSearchFocused = !!value
                    }, 100)
                }
            }
}
</script>
